import React, { Fragment } from "react";
import Header from "../../components/header/Header";
import sainDurAjiluud from "../../api/saindur";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Mcc from "../../components/mcc/Mcc";

const DonationSinglePage = ({ isDark, onToggleDark }) => {
  const { slug } = useParams();
  const Sainduruud = sainDurAjiluud.find((item) => item.slug === slug);

  // const SubmitHandler = (e) => {
  //   e.preventDefault();
  // };

  return (
    <Fragment>
      <Header isDark={isDark} hclass={"header--styleFour"} />
      <main className="main">
        <PageTitle
          pageTitle={Sainduruud.title}
          pagesub={"сайн-дур" + " / " + Sainduruud.slugMn}
          // pagesub={"Details 😃"}
          pageTop={"Portfolio"}
          tolink={"#sainDurZadargaa"}
        />
        <section className="donation pt-80 pb-30">
          <div className="container">
            <Mcc />
            <div className="row">
              <div className="col-lg-8 mb-30">
                <div className="innerWrapper">
                  <div id="sainDurZadargaa" className="donationDetails">
                    <div className="donationDetails__header mb-45">
                      <figure className="thumb mb-45">
                        <img src={Sainduruud.sImg} alt="сайн дур" />
                      </figure>
                      <h3 className="donationDetails__title text-uppercase">
                        {Sainduruud.title}
                      </h3>
                    </div>

                    <p className="donationDetails__text mb-30">
                      {Sainduruud.description}
                    </p>
                    {Sainduruud.description2 ? (
                      <p className="donationDetails__text mb-30">
                        {Sainduruud.description2}
                      </p>
                    ) : (
                      ""
                    )}
                    {Sainduruud.link ? (
                      <p>
                        <a
                          target="_blank"
                          className="btn btn--styleOne btn--primary it-btn"
                          href={Sainduruud.link}
                          rel="noreferrer"
                        >
                          <span className="btn__text">Дэлгэрэнгүй үзэх</span>
                        </a>
                      </p>
                    ) : (
                      ""
                    )}
                    {Sainduruud.img2 ? (
                      <figure className="thumb mb-45">
                        <img src={Sainduruud.img2} alt="сайн дур" />
                      </figure>
                    ) : null}
                    {Sainduruud.img3 ? (
                      <figure className="thumb mb-45">
                        <img src={Sainduruud.img3} alt="сайн дур" />
                      </figure>
                    ) : null}

                    {Sainduruud.description3 ? (
                      <p className="donationDetails__text mb-30">
                        {Sainduruud.description3}
                      </p>
                    ) : (
                      ""
                    )}
                    {Sainduruud.img4 ? (
                      <figure className="thumb mb-45">
                        <img src={Sainduruud.img4} alt="сайн дур" />
                      </figure>
                    ) : null}
                    {Sainduruud.date ? (
                      <p className="donationDetails__text mb-10">
                        {Sainduruud.date}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-30">
                <div className="sidebarLayout">
                  <div className="innerWrapperSidebar mb-30">
                    <div className="sidebarWidget">
                      <div className="sidebarTitle">
                        <h5 className="sidebarTitle__heading text-uppercase mb-30">
                          Сайн дурын ажлууд
                        </h5>
                      </div>
                      <div className="sidebarCategories">
                        <ul>
                          <li>
                            <Link to="">
                              <span>Бүх</span>
                              <span>{sainDurAjiluud.length}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="">
                              <span>Нийгэм</span>
                              <span>
                                {
                                  sainDurAjiluud.filter(
                                    (item) => item.category === "niigem",
                                  ).length
                                }
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link to="">
                              <span>Боловсрол</span>
                              <span>
                                {
                                  sainDurAjiluud.filter(
                                    (item) => item.category === "bolov",
                                  ).length
                                }
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link to="">
                              <span>Эрүүл мэнд</span>
                              <span>
                                {
                                  sainDurAjiluud.filter(
                                    (item) => item.category === "medic",
                                  ).length
                                }
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Mcc />
          </div>
        </section>
      </main>
      <Footer isDark={isDark} onToggleDark={onToggleDark} />
      <Scrollbar />
    </Fragment>
  );
};
export default DonationSinglePage;
